// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorPlanModel {
    static getAttributeTypeMap() {
        return PayorPlanModel.attributeTypeMap;
    }
}
PayorPlanModel.discriminator = undefined;
PayorPlanModel.attributeTypeMap = [
    {
        "name": "payorId",
        "baseName": "payorId",
        "type": "number"
    },
    {
        "name": "payorPlanId",
        "baseName": "payorPlanId",
        "type": "number"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<PayorSharedAddressModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<PayorSharedPhoneModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<PayorSharedEmailAddressModel>"
    },
    {
        "name": "webAddresses",
        "baseName": "webAddresses",
        "type": "Array<PayorSharedWebAddressModel>"
    },
    {
        "name": "payorPlanName",
        "baseName": "payorPlanName",
        "type": "string"
    },
    {
        "name": "payorPlanBin",
        "baseName": "payorPlanBin",
        "type": "string"
    },
    {
        "name": "payorPlanGroup",
        "baseName": "payorPlanGroup",
        "type": "string"
    },
    {
        "name": "payorPlanPcn",
        "baseName": "payorPlanPcn",
        "type": "string"
    },
    {
        "name": "payorMedicalId",
        "baseName": "payorMedicalId",
        "type": "string"
    },
    {
        "name": "isGovernmentInsurance",
        "baseName": "isGovernmentInsurance",
        "type": "boolean"
    },
    {
        "name": "isMedicalBenefit",
        "baseName": "isMedicalBenefit",
        "type": "boolean"
    },
    {
        "name": "planType",
        "baseName": "planType",
        "type": "PlanType"
    }
];
//# sourceMappingURL=payorPlanModel.js.map